import Main from '@/layout/main.vue'
import Blank from '@/layout/blank.vue'
const routes = [
  {
    path: '/operating',
    name: 'operating',
    meta: { title: '运营' },
    redirect: '/operating/group_welfare/points',
    component: Main,
    children: [{
      path: '/operating/group_welfare/points',
      name: 'lists',
      meta: {
        title: '群福利',
        parentPath: '/operating',
        icon: 'el-icon-present',
        permission: ['view']
      },
      component: Blank,
      redirect: '/operating/group_welfare/points',
      children: [
        {
          path: '/operating/group_welfare/points',
          name: 'group_welfare_point',
          meta: {
            title: '点位管理',
            parentPath: '/operating',
            permission: ['view']
          },
          component: () => import('@/views/operating/group_welfare/points.vue')
        },
        {
          path: '/operating/group_welfare/activity',
          name: 'group_welfare_activity',
          meta: {
            title: '活动管理',
            parentPath: '/operating',
            permission: ['view']
          },
          component: () => import('@/views/operating/group_welfare/activity.vue')
        },
        {
          path: '/operating/group_welfare/activity/data',
          name: 'group_welfare_activity_data',
          meta: {
            title: '活动数据',
            prevPath: '/operating/group_welfare/activity',
            parentPath: '/operating',
            permission: ['view'],
            hidden: true
          },
          component: () => import('@/views/operating/group_welfare/activity-data.vue')
        },
        {
          path: '/operating/group_welfare/purchase_order',
          name: 'group_welfare_purchase_order',
          meta: {
            title: '点位采购单',
            parentPath: '/operating',
            permission: ['view']
          },
          component: () => import('@/views/operating/group_welfare/purchase_order.vue')
        },
        {
          path: '/operating/group_welfare/purchase_order/detail',
          name: 'group_welfare_purchase_order',
          meta: {
            title: '点位采购单详情',
            parentPath: '/operating',
            prevPath: '/operating/group_welfare/purchase_order',
            permission: ['view'],
            hidden: true
          },
          component: () => import('@/views/operating/group_welfare/purchase_order_detail.vue')
        },
        {
          path: '/operating/group_welfare/sale_order',
          name: 'group_welfare_sale_order',
          meta: {
            title: '点位销售单',
            parentPath: '/operating',
            permission: ['view']
          },
          component: () => import('@/views/operating/group_welfare/sale_order.vue')
        },
        {
          path: '/operating/group_welfare/sale_order/detail',
          name: 'group_welfare_sale_order',
          meta: {
            title: '点位销售单详情',
            parentPath: '/operating',
            prevPath: '/operating/group_welfare/sale_order',
            permission: ['view'],
            hidden: true
          },
          component: () => import('@/views/operating/group_welfare/sales-detail.vue')
        },
        {
          path: '/operating/group_welfare/platform_bill',
          name: 'group_welfare_platform_bill',
          meta: {
            title: '平台账单',
            parentPath: '/operating',
            permission: ['view']
          },
          component: () => import('@/views/operating/group_welfare/platform_bill.vue')
        },
        {
          path: '/operating/group_welfare/point_label',
          name: 'group_welfare_point_label',
          meta: {
            title: '点位标签',
            parentPath: '/operating',
            permission: ['view']
          },
          component: () => import('@/views/operating/group_welfare/point_label.vue')
        },
        {
          path: '/operating/group_welfare/label_group',
          name: 'group_welfare_label_group',
          meta: {
            title: '标签分组管理',
            parentPath: '/operating',
            permission: ['view']
          },
          component: () => import('@/views/operating/group_welfare/label_group.vue')
        },
      ]
    },]
  }
]

export default routes
